import $ = require('jquery');
import Modul, {SaveResponse as ModulSaveResponse} from './Modul';

interface SaveResponse extends ModulSaveResponse {
    widgetContent: string;
    moduleId: string;
}

export default class ModulHtmlCode extends Modul {
    doAfterSave(r: SaveResponse) {
        super.doAfterSave(r);
        // updates the entered html code with
        // one that has parsed internal links
        if (r.widgetContent) {
            $('#htmlcode_' + r.moduleId).val(r.widgetContent);
        }
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/ModulHtmlCode.ts
 **/